export const baseURL = 'https://api.themoviedb.org/3'
export const API_KEY = '4ddbe43555cbd6a170bd160362f1162b'
export const imageUrl = 'https://image.tmdb.org/t/p/original'

